import { linkOptions } from '@tanstack/react-router';
import {
  Bell,
  Briefcase,
  Building2,
  CircleUser,
  ClipboardCheck,
  House,
  Ticket,
} from 'lucide-react';

/**
 * Top navigation. `linkOptions` type-checks every `to` against the registered router, so a
 * renamed route fails `tsc` here instead of 404-ing at runtime. `label`/`icon`/`gate` ride along.
 * `gate: 'organization'` hides the entry unless the caller may see organization tickets.
 */
export const NAV_ITEMS = linkOptions([
  { to: '/', label: 'Help center', icon: House, activeOptions: { exact: true } },
  { to: '/requests', label: 'My requests', icon: Ticket },
  { to: '/organization', label: 'My organization', icon: Building2, gate: 'organization' },
  { to: '/my-work', label: 'My work', icon: Briefcase },
  { to: '/approvals', label: 'Approvals', icon: ClipboardCheck },
  { to: '/notifications', label: 'Notifications', icon: Bell },
  { to: '/profile', label: 'Profile', icon: CircleUser },
]);

export type NavItem = (typeof NAV_ITEMS)[number];
